import { combineReducers } from "redux";
import { createStore } from "@reduxjs/toolkit";
import appBarReducer from "../features/AppBar/AppBarSlice";
import mainContentReducer from "../features/MainContent/MainContentSlice";
import sidebarReducer from "../features/Sidebar/SidebarSlice";
import clientReducer from "../features/client/clientSlice";
import localStorage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";
import { composeWithDevTools } from "@redux-devtools/extension";

const persistConfigSession = {
  key: "rootSession",
  storage: sessionStorage,
};

const persistConfigLocal = {
  key: "rootLocal",
  storage: localStorage,
};

const rootReducer = combineReducers({
  appBar: persistReducer(persistConfigLocal, appBarReducer),
  mainContent: mainContentReducer,
  sidebar: sidebarReducer,
  client: clientReducer,
});

const persistedReducer = persistReducer(persistConfigSession, rootReducer);

/* Create and export store with persisted state */
export const store = createStore(persistedReducer, composeWithDevTools());
export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
